import React from "react";

const CloudIcon = (props) => (
  <svg viewBox="0 0 100 100" {...props}>
    <path d="M67.655 89.027H59.82a1.565 1.565 0 0 1-1.565-1.565v-6.986a1.304 1.304 0 0 1 1.35-1.316h8.199a22.318 22.318 0 0 0 22.34-22.374c-.154-10.601-7.877-19.57-18.337-21.298h-.295a4.355 4.355 0 0 1-3.187-2.381l-.136-.273A22.874 22.874 0 0 0 47.492 19.85c-11.904.066-21.817 9.15-22.92 21.003v.363a4.355 4.355 0 0 1-2.857 3.754A17.918 17.918 0 0 0 9.898 60.687a17.6 17.6 0 0 0 32.57 10.115l6.657-10.988a1.293 1.293 0 0 1 1.769-.431l6.226 3.73c.605.372.797 1.162.43 1.77L50.872 75.95a27.467 27.467 0 1 1-35.734-38.92 32.888 32.888 0 0 1 60.74-10.763c14.096 3.49 24.028 16.098 24.121 30.62.182 17.657-14.64 32.139-32.343 32.139z" />
  </svg>
);

export default CloudIcon;
